/**
 * Utility function to construct full image URLs
 * Handles both absolute and relative paths
 * Uses environment variable for API base URL
 */

export const getImageUrl = (path: string | undefined | null): string => {
  // Return placeholder if no path provided
  if (!path) return '/placeholder-product.jpg';

  // Return as-is if already an absolute URL
  if (path.startsWith('http')) return path;

  // Get base domain URL (strip /api suffix since media files are at domain root)
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
  const apiBase = apiUrl.replace(/\/api\/?$/, '');

  // Ensure path starts with /
  const cleanPath = path.startsWith('/') ? path : `/${path}`;

  // Construct full URL
  return `${apiBase}${cleanPath}`;
};
